import './registration-form.css';

import '../../util/facebook-button/facebook-button';
import '../../util/recaptcha/recaptcha';

import './img/gauge_icon1.png';
import './img/gauge_icon1@2x.png';
